import { ElDefaults, Controls, SearchVariables, ProviderAuth, Toaster, SearchVariableFilters } from '@/gql'

// extract the name from a gql query
const getQueryName = query => query.definitions[0].name.value

// make a base item
const makeBaseItem = ({ query, value }) => {
  // extract the query Name
  const name = getQueryName(query)
  // inherit the value which would be the object to be written
  value = value || {}
  // make a new value adding the typename
  return { ...value, __typename: name }
}

// make suitable input to write query
const makePack = ({ query, item }) => {
  // the pack needs to look like this
  // {query, data:{objectname:{..content}}}
  const data = {}
  // add the data item
  data[item.__typename] = item
  // return the consolidated data,query
  return {
    query,
    data
  }
}

// get current state content
const getStateContent = ({ cache, query }) => {
  // extract the query Name
  const name = getQueryName(query)

  // pick up current value
  try {
    const content = cache.readQuery({ query })
    return content && content[name]
  } catch (err) {
    // this is required because empty cache seems to fail silently
    console.log('warning cache was empty', err)
    return Promise.resolve(null)

  }
}

// used for apollolocal state management
const stateMutate = ({ cache, key, value, name, merge, query }) => {
  if (!key && typeof merge !== 'object') {
    console.log('statemutate needs a key - for objects, use statereplace or statemerge', key, value, name, merge)
    return null
  }
  // set up ob to merge
  if (key) {
    merge = {}
    merge[key] = value
  }
  return stateMerge({ cache, merge, query })
}

// merge with existing state
const stateMerge = ({ cache, merge, query }) => {
  // get the current state
  const current = getStateContent({ cache, query })
  if (typeof merge !== 'object') {
    console.log('value should have been an object', {
      merge,
      query
    })
    merge = {}
  }
  // merge and commit
  return stateReplace({ cache, value: { ...current, ...merge }, query })
}

// replace an entire entry in cache
const stateReplace = ({ cache, value, query }) => {
  const item = makeBaseItem({ query, value })
  const pack = makePack({ query, item })
  cache.writeQuery(pack)
  return item
}

export default {
  Mutation: {
    updateToaster(_, { key, value, merge }, { cache }) {
      return stateMutate({ cache, key, value, merge, name: 'Toaster', query: Toaster })
    },
    updateControls(_, { key, value, merge }, { cache }) {
      return stateMutate({ cache, key, value, merge, name: 'Controls', query: Controls })
    },
    updateSearchVariables(_, { key, value, merge }, { cache }) {
      return stateMutate({ cache, key, value, merge, name: 'searchVariables', query: SearchVariables })
    },
    updateProviderAuth(_, { value }, { cache }) {
      return stateReplace({ cache, value, query: ProviderAuth })
    },
    updateSearchVariableFilters(_, { value }, { cache }) {
      return stateReplace({ cache, value, query: SearchVariableFilters })
    },
    updateElDefaults(_, { value }, { cache }) {
      return stateReplace({ cache, value, query: ElDefaults })
    }
  }
}
